import { SUBSCRIPTIONS_CANCEL_SUBSCRIPTION } from 'apiRoutes';
import { ConfirmationModal } from 'components/common/ConfirmationModal/ConfirmationModal';
import useSubmit, { POST } from 'hooks/useSubmit';

export const CancelSubscriptionModal: React.FC<{
	setShowModal: (show: boolean) => void;
	showModal: boolean;
	subscriptionId: number;
	onSubscriptionCancelled: () => void;
}> = ({ setShowModal, showModal, subscriptionId, onSubscriptionCancelled }) => {
	const [cancelSubscription, status] = useSubmit(
		`${SUBSCRIPTIONS_CANCEL_SUBSCRIPTION}`,
		POST,
		{
			messageOnError: 'An error occured, please try again!',
			messageOnSuccess: `Subscription cancelled successfully`,
			showApiError: true,
		},
	);

	const onCancelSubscription = async (comment?: string) => {
		const result = await cancelSubscription({
			subscriptionId: subscriptionId,
			comment: comment ?? null,
		});
		if (result.success) {
			onSubscriptionCancelled();
			setShowModal(false);
		}
	};

	return (
		<ConfirmationModal
			showModal={showModal}
			setShowModal={setShowModal}
			onSubmit={onCancelSubscription}
			header={'Cancel Subscription'}
			text={`Are you sure you want to cancel this subscription?`}
			buttonText={'Cancel Subscription'}
			loadingStatus={status}
		/>
	);
};
